import { fetchInquiryCount, getLiveChatUnreadCount } from "@/api/sidebar"
import { UnreadMap } from "../../types"
import { useAuth } from "@/use/biz/use-auth"
import { mktFunctionalBase } from "@shared/constants/privilege"
import tabtalk from "@shared/utils/tabtalk"

import Vue from "vue"

type FetchMap = {
  inquiryManagement: Function
}
type HasUnreadMenus = keyof FetchMap

interface FetchCountData {
  unread_count: number
}

const sidebarUnreadMap: UnreadMap = Vue.observable({
  inquiryManagement: 0,
  currentSession: 0,
})

const fetchUnreadCountMap = {
  inquiryManagement() {
    fetchInquiryCount({
      site_id: 0, // 暂时无需传siteId
      module: null, // module=1 cms模块 暂时传空表示所有
    }).then(({ data }) => {
      sidebarUnreadMap.inquiryManagement = data.unread_count
    })
  },
  currentSession() {
    getLiveChatUnreadCount({ channel_type: 3 }).then(({ data }) => {
      sidebarUnreadMap.currentSession = data?.unread_count || 0
    })
  },
}
export const useSidebarUnread = () => {
  const { checkPermission } = useAuth()
  const fetchSidebarUnread = (type: HasUnreadMenus) => {
    // 是否购买了MKT获取未读数 TODO:后续MKT权限系统完善后可能要改
    checkPermission(mktFunctionalBase) && fetchUnreadCountMap[type]()
  }

  const fetchSidebarAllUnread = () => {
    Object.keys(fetchUnreadCountMap).forEach((type) => {
      fetchSidebarUnread(type as HasUnreadMenus)
    })
  }
  return {
    sidebarUnreadMap,
    fetchSidebarUnread,
    fetchSidebarAllUnread,
  }
}
